import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { FiArrowUp } from 'react-icons/fi';
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import Homepage from './Components/Homepage';
import Aboutus from './Components/Home/Aboutus';
import QualityPage from './Components/Home/QualityPage';
import Contactus from './Components/Home/Contactus';
import Prefab from './Components/Home/Prefab';
import SteelFabrication from './Components/Home/SteelFabrication';
import RoofWallSheeting from './Components/Home/RoofWallSheeting';
import Projects from './Components/Home/Projects';
import Brochure from './Components/Home/Brochure';
import IndustrialSheds from './Components/Home/industrial';
import IndustrialStructures from './Components/Home/IndustrialStructures';
import FabricationServices from './Components/Home/FabricationServices';
import Enquiry from './Components/Home/Enquiry';
import Gallery from './Components/Home/Gallery';
import LocationsHub from './Components/Locations/LocationsHub';
import StatePage from './Components/Locations/StatePage';
import CityPage from './Components/Locations/CityPage';
import BlogIndex from './Components/Blog/BlogIndex';
import BlogPost from './Components/Blog/BlogPost';
import Products from './Components/Products';
import IndustriesHub from './Components/Industries/IndustriesHub';
import IndustryPage from './Components/Industries/IndustryPage';
import ServicePage from './Components/Services/ServicePage';
import PEBCostCalculator from './Components/PEBCostCalculator';
import SiteMap from './Components/SiteMap';
import GeneralFAQ from './Components/GeneralFAQ';
import NotFound from './Components/NotFound';
import { business } from './config/business';
import { trackPageView, trackWhatsAppClick, trackCallClick } from './utils/analytics';
import './App.css'; // Create this file if you don't have it

// Logs a GA4 page_view on every route change — SPA navigation doesn't
// trigger this on its own the way a full page load would.
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);
  return null;
}

export default function App() {
  return (
    <Router>
      <RouteTracker />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/quality" element={<QualityPage />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/pre-fab-structure-buildings" element={<Prefab />} />
        <Route path="/structure-steel-fabrication" element={<SteelFabrication />} />
        <Route path="/roof-wall-sheeting" element={<RoofWallSheeting />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/brochure" element={<Brochure />} />
        <Route path="/FabricationServices" element={<FabricationServices />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/industrial-sheds" element={<IndustrialSheds />} />
        <Route path='/IndustrialStructures' element={<IndustrialStructures />} />
        <Route path="/products" element={<Products />} />
        <Route path="/locations" element={<LocationsHub />} />
        <Route path="/locations/:stateSlug" element={<StatePage />} />
        <Route path="/locations/:stateSlug/:citySlug" element={<CityPage />} />
        <Route path="/resources" element={<BlogIndex />} />
        <Route path="/resources/:slug" element={<BlogPost />} />
        <Route path="/industries" element={<IndustriesHub />} />
        <Route path="/industries/:slug" element={<IndustryPage />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/peb-erection" element={<ServicePage />} />
        <Route path="/design-engineering" element={<ServicePage />} />
        <Route path="/peb-cost-calculator" element={<PEBCostCalculator />} />
        <Route path="/sitemap" element={<SiteMap />} />
        <Route path="/faq" element={<GeneralFAQ />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* WhatsApp Chat Widget - Responsive */}
      <div
        className="whatsapp-widget"
        onClick={() => {
          trackWhatsAppClick('floating_widget');
          window.open(business.whatsapp.href, '_blank');
        }}
        role="button"
        tabIndex={0}
        aria-label="Chat with TR Structures on WhatsApp"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            trackWhatsAppClick('floating_widget');
            window.open(business.whatsapp.href, '_blank');
          }
        }}
      >
        <FaWhatsapp className="whatsapp-icon" aria-hidden="true" />
        <span className="whatsapp-label">Chat with us</span>
      </div>

      {/* Sticky mobile Call + WhatsApp bar — the fastest path to a lead on a
          phone screen, where a floating icon alone is easy to miss. */}
      <div className="mobile-cta-bar">
        <a
          href={business.phone.href}
          className="mobile-cta-btn mobile-cta-call"
          onClick={() => trackCallClick('mobile_sticky_bar')}
        >
          <FaPhoneAlt aria-hidden="true" />
          <span>Call Now</span>
        </a>
        <a
          href={business.whatsapp.href}
          target="_blank"
          rel="noopener noreferrer"
          className="mobile-cta-btn mobile-cta-whatsapp"
          onClick={() => trackWhatsAppClick('mobile_sticky_bar')}
        >
          <FaWhatsapp aria-hidden="true" />
          <span>WhatsApp</span>
        </a>
      </div>

      {/* Scroll to Top - Responsive */}
      <div className="scroll-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <FiArrowUp className="arrow-icon" />
      </div>
    </Router>
  );
}